import React from 'react';
import { parseColor } from '../../utilities/colors';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import styles from './styles.module.css';

type AnyFunc = (...props: any[]) => any;
export type DropdownProps = {
  /**
   * Array of selectable options for the dropdown
   */
  options?: (number | string)[];
  /**
   * Function to execute when a selection is made
   */
  onChange: AnyFunc;
  /**
   * Function to determine key and what is shown in dropdown
   * Default: v => v
   */
  parser: AnyFunc;
  /**
   * Current value to set for the dropdown. First item selected if not set.
   */
  value?: string;
  /*
   * Color to show text in
   */
  color?: string;
  /*
   * Label to be shwon
   */
  label?: string;
};

const Dropdown = ({ options, onChange, parser = (v) => v, value, color, label }: DropdownProps) => {
  const asSelect = options.length > 1;

  return (
    <span
      className={`${styles['dropdown-wrapper'] as string} ${
        styles[asSelect && 'as-select'] as string
      }`}
      style={{ color: parseColor(color, '') }}
    >
      {label && <span className={styles['dropdown-spacer']}>{label}</span>}
      {asSelect ? (
        <select className={styles['dropdown-select']} onChange={onChange} value={parser(value)}>
          {options.map((option) => {
            const parsed = parser(option);
            return <option key={parsed}>{parsed}</option>;
          })}
        </select>
      ) : (
        <span className={styles['dropdown-single']}>{parser(options[0])}</span>
      )}
    </span>
  );
};

export default Dropdown;
